import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForYouSection() {
  return <section className="py-24 px-6 bg-[#0c1220]" data-id="element-26">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-27">
        {/* For You */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-[#111827]/50 p-8 rounded-2xl border border-[#c9956b]/20" data-id="element-28">
          <h3 className="text-2xl font-bold text-[#f5efe3] mb-8 flex items-center gap-3" data-id="element-29">
            <span className="text-[#c9956b]" data-id="element-30">Esto es para ti</span> si...
          </h3>
          <ul className="space-y-4" data-id="element-31">
            {['De día funcionas, pero de noche te rompes en silencio', 'Tu ansiedad nocturna está alimentada por pendientes y culpa', 'Te exiges descanso… y te castigas con pensamientos', 'Quieres algo simple que puedas hacer incluso cansado', 'Compras impulsivamente soluciones cuando ya no aguantas más'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#f0e6d3]/90" data-id="element-32">
                <Check className="w-5 h-5 text-[#c9956b] shrink-0 mt-0.5" data-id="element-33" />
                <span data-id="element-34">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Not For You */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-[#111827]/30 p-8 rounded-2xl border border-white/5" data-id="element-35">
          <h3 className="text-2xl font-bold text-[#8b9bb4] mb-8 flex items-center gap-3" data-id="element-36">
            Esto{' '}
            <span className="text-white/40 line-through decoration-red-400/50" data-id="element-37">
              NO
            </span>{' '}
            es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-38">
            {["Buscas diagnóstico, promesas médicas, o 'curarte' con un PDF", 'Quieres una solución mágica sin repetir nada', 'Te gusta más entender el problema que hacer un protocolo corto'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#8b9bb4]" data-id="element-39">
                <X className="w-5 h-5 text-red-400/50 shrink-0 mt-0.5" data-id="element-40" />
                <span data-id="element-41">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}